import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { Pagination } from './pagination';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  private _pagination: BehaviorSubject<Pagination>;

  constructor() {}

  public getPaginationState() {
    return this._pagination && this._pagination.getValue();
  }

  public subscribePaginationState() {
    return this._pagination.asObservable();
  }

  public initPagination(options: Pagination) {
    this._pagination = <BehaviorSubject<Pagination>>new BehaviorSubject(options);
  }

  public updatePaginationLoadPartial(countLoaded: number, limitCountMaxRows: number) {
    const subject = this.getPaginationState();

    if (!subject) {
      return;
    }

    subject.offset = countLoaded;
    subject.countLoaded = countLoaded;
    subject.limitCountMaxRows = limitCountMaxRows;

    this._updateSubject(subject);
  }

  public changeLimitSelected(limit: number) {
    const subject = this.getPaginationState();
    subject.limitSelected = limit;

    this._updateSubject(subject);
  }

  private _updateSubject(subject) {
    this._pagination.next(subject);
  }
}
